/**
 * Search API Client
 * Provides message search across all BYOH hosts via orchestration-service fan-out.
 */

import { apiClient, type CancellableRequest } from './api-client'

// Fields match backend snake_case JSON (apiClient does not auto-convert keys)
export interface SearchResult {
  id: string
  created_at: string
  mission_id?: string
  agent_id: string
  role: 'user' | 'assistant'
  content: string
  snippet: string
  session_id: string
  host_id: string
  execution_id?: string
  mission_name?: string
  agent_name?: string
  user_name?: string
}

export interface SearchResponse {
  results: SearchResult[]
  total: number
  query: string
  hosts_queried: number
  hosts_responded: number
}

export const searchApi = {
  /**
   * Search messages across all online BYOH hosts.
   * Uses orchestration-service fan-out to query each host in parallel.
   */
  searchMessages: (query: string, limit = 50): CancellableRequest<SearchResponse> =>
    apiClient.getCancellable<SearchResponse>('/v1/orchestration/search/messages', {
      q: query,
      limit: String(limit),
    }),
}
